export default __webpack_public_path__ + "static/media/paper-3.01988026.pdf";